import React, { ReactElement } from 'react';
import { Drawer as AntDrawer } from 'antd';
import styled from 'styled-components';

interface CustomStyles {
  padding: string;
}

interface SidePanelProps {
  title?: React.ReactNode;
  children?: React.ReactNode;
  footer?: React.ReactNode;
  onClose?: () => void;
  onOpen?: () => void;
  visible?: boolean;
  size?: PanelSize;
  width?: number | string;
  destroyOnClose?: boolean;
  closable?: boolean;
  maskClosable?: boolean;
  className?: string;
  customStyles?: CustomStyles;
}

type PanelSize = 'default' | 'large';

function SidePanel({
  title,
  footer,
  children,
  onClose,
  onOpen,
  visible,
  size,
  width,
  destroyOnClose,
  closable,
  maskClosable,
  className,
  customStyles,
}: SidePanelProps): ReactElement {
  return (
    <StyledDrawer
      className={className}
      title={title}
      footer={footer}
      closable={closable}
      maskClosable={maskClosable ?? closable}
      onClose={onClose}
      placement={'right'}
      open={visible}
      size={size}
      width={width}
      destroyOnClose={destroyOnClose}
      afterOpenChange={open => open && onOpen && onOpen()}
      customstyles={customStyles}
    >
      {children}
    </StyledDrawer>
  );
}

const StyledDrawer = styled(AntDrawer)<{ customstyles?: CustomStyles }>`
  .ant-drawer-body {
    padding: ${props => props.customstyles?.padding};
  }

  & {
    .ant-drawer-header-title {
      flex-direction: row-reverse;

      .ant-drawer-title {
      }
      .ant-drawer-close {
        margin: 0 0 0 12px;
      }
    }
  }
`;

export default SidePanel;
